import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { darkGrey, green } from '../../styles/constants';

const Td = styled.td.withConfig({
  shouldForwardProp: (prop) => !['color'].includes(prop),
})`
  background-color: ${(props) => (props.color)};
  height: 5px;
  border-left: 1px solid rgba(128,128,128,0.35);
`;

const StyledTable = styled.table`
  width: 100%;
  font-size: 0.8rem;
  color: ${darkGrey};
  table-layout: fixed;
  
  tfoot {
    td {
    border-top: 1px solid rgba(128,128,128,0.35);
    }
  }
`;

const tdPerHalfMonth = [
  { month: 0, day: 1 },
  { month: 0, day: 15 },
  { month: 1, day: 1 },
  { month: 1, day: 15 },
  { month: 2, day: 1 },
  { month: 2, day: 15 },
  { month: 3, day: 1 },
  { month: 3, day: 15 },
  { month: 4, day: 1 },
  { month: 4, day: 15 },
  { month: 5, day: 1 },
  { month: 5, day: 15 },
  { month: 6, day: 1 },
  { month: 6, day: 15 },
  { month: 7, day: 1 },
  { month: 7, day: 15 },
  { month: 8, day: 1 },
  { month: 8, day: 15 },
  { month: 9, day: 1 },
  { month: 9, day: 15 },
  { month: 10, day: 1 },
  { month: 10, day: 15 },
  { month: 11, day: 1 },
  { month: 11, day: 15 },
];

const renderRanges = (ranges) => {
  const formattedRanges = ranges.map((range) => {
    const startDate = new Date(range.start);
    const endDate = new Date(range.end);
    const start = {
      month: startDate.getMonth(),
      day: endDate.getDate(),
    };
    const end = {
      month: endDate.getMonth(),
      day: endDate.getDate(),
    };
    return {
      start,
      end,
    };
  });

  let activeRangeIndex = 0;
  let rangeInProgress = false;
  let visualizeRangesDone = false;
  return tdPerHalfMonth.map((cellInfo) => {
    const key = `${cellInfo.month}, ${cellInfo.day}`;
    if (visualizeRangesDone) {
      return <Td key={key} color="transparent" />;
    }
    // If hasn't started yet, check if it does now
    if (!rangeInProgress) {
      if (formattedRanges[activeRangeIndex].start.month === cellInfo.month
        && formattedRanges[activeRangeIndex].start.day === cellInfo.day) {
        rangeInProgress = true;

        return <Td key={key} color={green} />;
      }

      return <Td key={key} color="transparent" />;
    }

    if (rangeInProgress) {
      // If range started already, check if it now stops
      if (formattedRanges[activeRangeIndex].end.month === cellInfo.month
        && formattedRanges[activeRangeIndex].end.day === cellInfo.day) {
        rangeInProgress = false;

        if (typeof formattedRanges[activeRangeIndex + 1] === 'undefined') {
          visualizeRangesDone = true;
        }

        activeRangeIndex += 1;

        return <Td key={key} color="transparent" />;
      }

      return <Td key={key} color={green} />;
    }

    return <Td key={key} color="transparent" />;
  });
};
const RangeChart = ({ ranges }) => {
  if (!ranges || ranges.length === 0) {
    return null;
  }

  const rangeTds = renderRanges(ranges);

  return (
    <StyledTable>
      <tbody>
        <tr>
          {rangeTds}
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <td>Jan</td>
          <td />
          <td>Feb</td>
          <td />
          <td>Mar</td>
          <td />
          <td>Apr</td>
          <td />
          <td>Mei</td>
          <td />
          <td>Jun</td>
          <td />
          <td>Jul</td>
          <td />
          <td>Aug</td>
          <td />
          <td>Sep</td>
          <td />
          <td>Okt</td>
          <td />
          <td>Nov</td>
          <td />
          <td>Dec</td>
          <td />
        </tr>
      </tfoot>
    </StyledTable>
  );
};

RangeChart.propTypes = {
  ranges: PropTypes.arrayOf(
    PropTypes.shape({
      start: PropTypes.string.isRequired,
      end: PropTypes.string.isRequired,
    }),
  ).isRequired,
};

export default RangeChart;
